'use client';
import { MultiSelect, TagsInput } from '@mantine/core';

import { Button } from '@scaleup/frontend/ui';
import {
  industriesServed,
  primaryCustomers,
  revenueChannels,
  Supplier,
} from '@scaleup/models';
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';
import { IntakeBase } from './common';
import { useSupplierIntakeContext } from './context';
import { useState } from 'react';

export const Industry = () => {
  const {
    setCurrentStep,
    industryForm,
    supplier,
    updateSupplier,
    lastStep,
    setLastStep,
  } = useSupplierIntakeContext();
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    const { hasErrors } = industryForm.validate();
    if (hasErrors) {
      return;
    }
    if (!industryForm.isDirty()) {
      if (lastStep === 'review') {
        setLastStep('industry');
        setCurrentStep('review');
      } else {
        setLastStep('industry');
        setCurrentStep('structure');
      }
      return;
    }
    const supplierData = {
      ...supplier.supplierData,
      ...industryForm.values,
    };

    setLoading(true);
    updateSupplier({
      ...supplier,
      supplierData: supplierData,
    })
      .then((newSupplier: Supplier) => {
        setLoading(false);
        console.log('Updated supplier', newSupplier);
        if (lastStep === 'review') {
          setLastStep('industry');
          setCurrentStep('review');
        } else {
          setLastStep('industry');
          setCurrentStep('structure');
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <IntakeBase currentStep={2}>
      <div className="flex flex-col gap-2">
        <p className="text-text-primary font-bold text-xl">
          Market Presence & Customer Base
        </p>

        <p className="text-text-secondary">
          Tell us about your industry focus, target markets, and the sectors you
          serve.
        </p>
      </div>

      <div className="rounded-[1rem] bg-primary-25 p-8 my-8 w-full min-h-[20rem] flex flex-col gap-4 items-center justify-center">
        <div className="flex flex-col gap-4 w-full">
          <div className="flex gap-4 w-full">
            <div className="w-1/2">
              <MultiSelect
                required
                maxValues={5}
                label="What are your primary customer types?"
                classNames={{ input: 'w-full' }}
                data={primaryCustomers}
                error={industryForm.errors.customerTypes}
                {...industryForm.getInputProps('customerTypes')}
              />
            </div>
            <div className="w-1/2">
              <MultiSelect
                label="Select the top 5 Industries you serve"
                required
                maxValues={5}
                classNames={{ input: 'w-full' }}
                data={Array.from(Object.keys(industriesServed)).map((it) => ({
                  group: it,
                  //   @ts-ignore
                  items: industriesServed[it],
                }))}
                error={industryForm.errors.top5Industries}
                {...industryForm.getInputProps('top5Industries')}
              />
            </div>
          </div>

          <div className="flex gap-4 w-full">
            <div className="w-1/2">
              <MultiSelect
                required
                maxValues={5}
                label="Top 5 Revenue Channels"
                classNames={{ input: 'w-full' }}
                data={revenueChannels}
                error={industryForm.errors.primarySalesChannels}
                {...industryForm.getInputProps('primarySalesChannels')}
              />
            </div>
            <div className="w-1/2">
              <TagsInput
                label="Existing Customers (companies we should exclude in the matching process.)"
                classNames={{ input: 'w-full' }}
                error={industryForm.errors.currentCustomers}
                {...industryForm.getInputProps('currentCustomers')}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between">
        <Button
          text="Back"
          variant="secondary"
          prefixIcon={<IconArrowLeft />}
          onClick={() => {
            if (lastStep === 'review') {
              setLastStep('industry');
              setCurrentStep('review');
            } else {
              setLastStep('industry');
              setCurrentStep('demographics');
            }
          }}
        />

        <Button
          text="Continue"
          variant="primary"
          suffixIcon={<IconArrowRight />}
          onClick={handleClick}
          loading={loading}
        />
      </div>
    </IntakeBase>
  );
};
